import Colors from "../assets/constants/Colors";
import { Spacers } from "../assets/constants/Spacers";
import {
  experienceTitleId
} from "../assets/constants/Strings";
import CustomGrid from "../components/CustomGrid";
import { softwareEngineeringExperiences } from "../pages/Home.constants";
import styled from "../styled-components";
import { homeContent } from "./Home.constants";

const { pageContent } = Spacers;

const Experience = () => {

  return (
    <PageContainer>
      <PageContentContainer>
        <SectionTitleText id={experienceTitleId}>{homeContent.experienceTitle}</SectionTitleText>
        {/*TODO: Remove and add a proper spacer*/}
        <PageSectionContainer/>

        <SectionSubTitleText>{"Projects"}</SectionSubTitleText>

        <OverlineRow>
          <Overline>{"Software Automation and Engineering"}</Overline>
          <RuleFirst aria-hidden="true" />
        </OverlineRow>
        <BodyText>{" Ask me about React, React Native, iOS, Google Apps Scripts/Sheets, HTML/JS/Python, Github."}</BodyText>
        {/* <SectionSubHeaderText>Software Engineering</SectionSubHeaderText> */}
        <PageSectionContainer>
          <CustomGrid experiences={softwareEngineeringExperiences}/>
        </PageSectionContainer>
      
        {/*TODO: Remove and add a proper spacer*/}
        <PageSectionContainer/>

        <SectionSubTitleText>{"Education and Certificates"}</SectionSubTitleText>
        <PageSectionContainer>

          <ul>
            <li>
              <BodyText>{"University of California, Davis, B.S. in Computer Engineering, 12/2017"}</BodyText>
            </li>
            <li>
              <BodyText>{"Google Data Analytics Certificate, Coursera, 2025 "} <a
                href="https://www.coursera.org/account/accomplishments/certificate/FLF7Q8K3TA5L"
                target="_blank"
                rel="noreferrer"
                aria-label="View Google Data Analytics Certificate on Coursera"
              >
                View
              </a></BodyText>
            </li>
            <li>
              <BodyText>{"Google Foundations of Project Management, Coursera, 2025 "}<a
                href="https://www.coursera.org/account/accomplishments/records/9NSZOP2HBU5U"
                target="_blank"
                rel="noreferrer"
                aria-label="View Google Foundations of Project Management on Coursera"
              >
                View
              </a></BodyText>
            </li>
            <li>
              <BodyText>{"User Experience for Web Design, Lynda.com, 2018 "}<a
                href="http://www.lynda.com/User-Experience-tutorials/User-Experience-Fundamentals-Web-Design/421802-2.html"
                target="_blank"
                rel="noreferrer"
                aria-label="View GUser Experience for Web Design on LinkedIn"
              >
                View
              </a></BodyText>
            </li>
          </ul>
        </PageSectionContainer>
      </PageContentContainer>
    </PageContainer>
  );
};
export default Experience;

export const cardStyles = {
  alignItems: "center",
  backgroundColor: Colors.surfaceForeground,
  borderColor: Colors.surfaceForegroundBorder,
  marginBottom: "15px",
};

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const PageContentContainer = styled.div`
  max-width: ${pageContent.maxWidth.px};
  margin: 0 auto;
  padding: ${pageContent.padding.top.px} ${pageContent.padding.horizontal.px} ${pageContent.padding.bottom.px};
  overflow: auto;
`;

const PageSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 25px;
`;

const SectionTitleText = styled.h2``;
const SectionSubTitleText = styled.h3``;

const OverlineRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 12px;
`;

const Overline = styled.span`
  color: #8a8a8a;
  font-size: 14px;
  letter-spacing: 0.4px;
`;

const RuleFirst = styled.span`
  height: 2px;
  width: 255px;
  background: #e5e5e5;
  border-radius: 2px;
`;

const BodyText = styled.p``;